import React from 'react';
import './StructureSection.css';
import { getScoreColorClass } from 'utils/scoreColors';
import { useTranslation } from 'react-i18next';

const StructureSection = ({ data, wordCount }) => {
  const { t } = useTranslation();

  const textLength = data?.textLength || { score: 0, target: 0 };
  const readingTime = data?.readingTime || { minutes: 0 };
  const contentFormats = data?.contentFormats || { score: 0, count: 0, required: 0, recommendation: '' };
  
  return (
    <div className="structure-section">
      {/* Text Length Section */}
      <div className="metric-subsection">
        <div className="subsection-header">
          <div className="subsection-title">{t('Longueur du texte')} :</div>
          <div
            className={`subsection-score ${getScoreColorClass(
              textLength.score
            )}`}
          >
            {textLength.score}%
          </div>
        </div>

        <div className="subsection-content">
          <div className="progress-container">
            <div className="progress-bar">
              <div
                className={`progress-fill  ${getScoreColorClass(
                  textLength.score
                )}`}
                style={{ width: `${textLength.score}%` }}
              ></div>
            </div>
            <div className="progress-labels">
              <span className="current-value">
                {wordCount || 0} {t('mots')}
              </span>
              <span className="target-value">
                {t('objectif')} {textLength.target}
              </span>
            </div>
          </div>

          <div className="reading-time">
            <span className="time-icon">
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 15.333A6.833 6.833 0 1 0 8 1.666a6.833 6.833 0 0 0 0 13.667zM13.334 8.5a5.333 5.333 0 1 1-10.667 0 5.333 5.333 0 0 1 10.667 0zM8.75 5.167a.75.75 0 0 0-1.5 0v2.919c0 .464.185.909.513 1.237l1.04 1.04a.75.75 0 1 0 1.061-1.06l-1.04-1.04a.25.25 0 0 1-.074-.177v-2.92z"
                  fill="#3C3C3C"
                />
              </svg>
            </span>{' '}
            {t('Temps de lecture')} :{' '}
            <strong>{readingTime.minutes} min</strong>
          </div>
        </div>
      </div>

      {/* Content Formats Section */}
      <div className="metric-subsection">
        <div className="subsection-header">
          <div className="subsection-title">
            {t('Formats de contenus variés')} :
          </div>
          <div
            className={`subsection-score  ${getScoreColorClass(
              contentFormats.score
            )}`}
          >
            {contentFormats.score}%
          </div>
        </div>

        <div className="subsection-content">
          <p className="metric-text">
            {t('Vous avez')} {contentFormats.count} format
            {contentFormats.count > 1 ? 's' : ''} {t('de contenu sur')}{' '}
            {contentFormats.required}{' '}
            {t('requis')}.
          </p>
          {contentFormats.recommendation && (
            <div className="recommendation">
              <span className="recommendation-icon"></span>
              <div className="recommendation-content">
                <span className="recommendation-label">
                  {t('Notre recommandation')} :{' '}
                </span>
                <span className="recommendation-text">
                  {t(contentFormats.recommendation)}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StructureSection;
